var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCompactor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.4 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Trash Compactor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.7 1c-0.4-0.5-1-0.8-1.6-0.8h-20c-0.5 0-1 0.2-1.5 0.8-0.4 0.5-0.6 1.2-0.6 1.9v39c0 1.1 0.6 2.1 1.4 2.5v3.4h21.3v-3.4c0.9-0.3 1.6-1.4 1.6-2.6v-39c0.1-0.6-0.1-1.3-0.6-1.8zm-21.5 0.7h20c0.3 0 0.5 0.1 0.7 0.4l0.3 0.6h-21.9c0.1-0.6 0.4-1 0.9-1zm19.9 44.7h-19.3v-1.4h19.2v1.4zm1.1-4.5c0 0.3-0.1 0.6-0.3 0.9s-0.5 0.4-0.7 0.4h-20c-0.6 0-1-0.6-1-1.2v-38.2h22v38.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3,6.7H20c0.3,0,0.5-0.2,0.5-0.5S20.3,5.6,20,5.6H4.3C4,5.6,3.8,5.8,3.8,6.1S4,6.7,4.3,6.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.2 42c0.1 0.1 0.2 0.1 0.3 0.1s0.2-0.1 0.3-0.1c0.2-0.2 0.2-0.4 0-0.6l-4.9-4.9c-0.1-0.1-0.2-0.1-0.3-0.1s-0.2 0-0.3 0.1c-0.2 0.2-0.2 0.4 0 0.6l4.9 4.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m4.3 42c0.1 0.1 0.2 0.1 0.3 0.1 0.2 0 0.3-0.1 0.4-0.2s0-0.3-0.1-0.4l-2-2c-0.1-0.1-0.2-0.1-0.3-0.1s-0.2 0-0.3 0.1c-0.2 0.2-0.2 0.4 0 0.6l2 1.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCompactor);
export default __webpack_public_path__ + "static/media/trash-compactor.35731d807c668f62cde78206cd4c1aef.svg";
export { ForwardRef as ReactComponent };